import AuthSvcMod from '@Services/Auth.svc.js';
/** @typedef {import('./Metrics.svc')} Types */
//
export class Metrics {
	constructor($log, ENV, AuthSvc, VERSION, $window, DATA_DOG_CONFIG, G_TAG_ID) {
		'ngInject';
		this.env = ENV;
		this.$log = $log;
		this.authService = AuthSvc;
		this.datadogRum = null;
		this.APP_VERSION = VERSION.replace(/version_/i, '').replace(/_/g, '.');
		this.window = $window;
		this.guess = {id: null, name: 'Guess', email: null};
		this.datadogConfig = DATA_DOG_CONFIG;
		this.GT_ID = G_TAG_ID;

		this.dataLayer = window.dataLayer || [];

		window.dataLayer = window.dataLayer || [];
		$window.addEventListener('message', e => {
			if (e.origin === 'https://www.googletagmanager.com') {
				this.setDataLayer(e.data.dataLayer);
			}
		});
	}

	init() {
		this.$log.info(`MetricsSvc started for ${this.env}`);
		if (this.env === 'local') this.env = 'development';
		// RUM — dynamic import to reduce initial bundle (~150 KB)
		import(/* webpackChunkName: "datadog-rum" */ '@datadog/browser-rum')
			.then(({datadogRum}) => {
				this.datadogRum = datadogRum;
				this.datadogRum.init({
					beforeSend: event => {
						if (event.type === 'resource') return false;
						event.view.url = this.window.location.href;
					},
					applicationId: this.datadogConfig[this.env]?.applicationId,
					clientToken: this.datadogConfig[this.env]?.clientToken,
					useCrossSiteSessionCookie: true,
					site: 'datadoghq.com',
					service: this.datadogConfig[this.env]?.service,
					env: this.env,
					version: this.APP_VERSION, // Specify a version number to identify the deployed version
					sampleRate: 100,
					trackInteractions: true,
					trackBfcacheViews: true,
					defaultPrivacyLevel: 'allow',
					// enableExperimentalFeatures: ['feature_flags'],
				});

				this.setUser();
			})
			.catch(err => this.$log.error('Failed to load DataDog RUM', err));

		this.gtag('config', this.GT_ID);
	}

	/**
	 * @param {string} name
	 * @param {Record<string, unknown>} [dataObj]
	 */
	log(name, dataObj) {
		if (this.datadogRum) this.datadogRum.addAction(name, dataObj);
		this.gtag('event', name, dataObj);
	}

	/** @param {Types.MetricsUser} [user] */
	setUser(user) {
		let _currentUser;
		if (user) _currentUser = user;
		if (!user) _currentUser = this.getCurrentUser();
		if (this.datadogRum) {
			this.datadogRum.setUser({
				id: _currentUser.id,
				name: `${_currentUser.first_name} ${_currentUser.last_name}`,
				email: _currentUser.email,
			});
		}
		this.gtag('config', this.GT_ID, {user_id: _currentUser.id});
	}

	resetUser() {
		this.setUser(this.guess);
	}

	gtag() {
		if (window && window?.dataLayer) {
			// eslint-disable-next-line no-undef
			dataLayer.push(arguments);
		} else {
			this.$log('dataLayer nor available', arguments);
		}
	}

	getCurrentUser() {
		const _currentUser = this.authService.currentUser();
		if (!_currentUser) return this.guess;
		return _currentUser;
	}

	/** @param {unknown[]} newDataLayer */
	setDataLayer(newDataLayer) {
		this.dataLayer = newDataLayer;
	}
}
//
let compMod = angular.module('mod.svc.MetricsSvc', [AuthSvcMod]).service('MetricsSvc', Metrics);
export default (compMod = compMod.name);
